export default {
  // মোড
  "common.mode.auto": "স্ব-উৎপাদন এবং স্ব-ব্যবহার",
  "common.mode.economy": "অর্থনৈতিক মোড",
  "common.mode.exigency": "জরুরি মোড",

  // ডিভাইস
  "common.grid": "গ্রিড",
  'common.evChargers': 'চার্জিং স্টেশন',
  'common.evCharger': 'চার্জিং স্টেশন',
  'common.pv': 'সোলার প্যানেল',
  'common.inverter': 'ইনভার্টার',
  'common.pcs': 'ইনভার্টার + ব্যাটারি',
  'common.terminal': 'টার্মিনাল ডিভাইস',
  'common.airc': 'এয়ার কন্ডিশনার',
  'common.engine': 'ইঞ্জিন',
  'common.battery': 'ব্যাটারি',
  'common.metter': 'বৈদ্যুতিক মিটার',
  'common.other': 'অন্যান্য',
  "common.power": "ক্ষমতা",
  "common.powerTotal": "মোট ক্ষমতা",
  "common.voltage": "ভোল্টেজ",
  "common.electricity": "বিদ্যুৎ",
  "common.current": "কারেন্ট",
  "common.homeUsage": "পারিবারিক মোট লোড",
  "common.battery.power": "ব্যাটারির ক্ষমতা",

  // ডেটা
  "common.noDataAvailable": 'কোনো ডেটা উপলব্ধ নেই~',
  'common.tips': 'টিপস',
  "common.reset": "রিসেট",
  "common.currencyUnit": '৳',
  "common.submiting": 'জমা দেওয়া হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
  "common.close": 'বন্ধ',
  "common.from": 'থেকে',
  "common.useIn": 'ব্যবহৃত',
  "common.energyPercent": 'শক্তি প্রবাহের অনুপাত',
  "common.dataFlow": "ডেটা প্রবাহ",
  "common.getDataIng": 'ডেটা লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
  "common.pageLoading": 'পৃষ্ঠার কন্টেন্ট লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
  "common.reseting": "পৃষ্ঠার কন্টেন্ট রিসেট হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...",
  "common.save": 'সংরক্ষণ',
  "common.onlyNumberTips": "শুধুমাত্র সংখ্যা পূরণ করা যায়",
  "common.offline": "অফলাইন",
  "common.online": "অনলাইন",
  "common.fault":"ত্রুটি",
  "common.charge": "চার্জ",
  "common.discharge": "ডিসচার্জ",
  "common.buy": "কিনুন",
  "common.sell": "বিক্রয়",
  "common.loadingInfo": 'লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',

  // 
  "common.moreFeatures": "আরও বৈশিষ্ট্য",
  "common.confirm": 'নিশ্চিত',
  "common.saveing": "সংরক্ষণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...",
  "common.searchPlacholder": "অনুসন্ধানের কীওয়ার্ড লিখুন",
  "common.iSee": 'আমি বুঝেছি',
  "common.pageErrorTips1": "ওহ, ওয়েবপৃষ্ঠায় ত্রুটি হয়েছে~",
  "common.pageErrorTips2": "অনুগ্রহ করে রিফ্রেশ করার চেষ্টা করুন বা গ্রাহক সেবার সাথে যোগাযোগ করুন~",
  "common.refresh": "রিফ্রেশ",
  "common.backToHome": "হোম পেজে ফিরুন",
  "common.checkTips": "যাচাই করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...",
  "common.back": "ফেরত",
  "common.cancel": "বাতিল",
  "common.optional": "ঐচ্ছিক",
  "common.required": "আবশ্যক",
  "common.status": "অবস্থা",
  "common.statusNoDelete": "মুছে ফেলা হয়নি",
  "common.statusDelete": "মুছে ফেলা হয়েছে",
  "common.submit": 'জমা দিন',
  "common.disable": "নিষ্ক্রিয়",
  "common.enable": "সক্রিয়",
  "common.year": 'বছর',
  "common.month": 'মাস',
  "common.day": 'দিন',
  "common.version": 'সংস্করণ নম্বর：',
  "common.backHome": ' হোম পেজে ফিরুন',
  "common.backHomeSorry": ' দুঃখিত, পৃষ্ঠাটি দুর্ঘটনাক্রমে পথ হারিয়েছে',
  "common.requestTips1": 'ডেটা প্রক্রিয়া করা হচ্ছে, অনুগ্রহ করে পুনরায় জমা দেবেন না',
  "common.requestTips2": "সিস্টেম প্রম্পট",
  "common.requestTips3": "লগইন অবস্থার মেয়াদ শেষ হয়ে গেছে, অনুগ্রহ করে পুনরায় লগইন করুন",
  "common.requestTips4": "পুনরায় লগইন",
  "common.requestTips5": "অবৈধ সেশন, অথবা সেশনের মেয়াদ শেষ হয়ে গেছে, অনুগ্রহ করে পুনরায় লগইন করুন।",
  "common.requestTips6": "সার্ভারে ত্রুটি হয়েছে, পরে আবার চেষ্টা করুন.",
  "common.requestTips7": "সিস্টেম ইন্টারফেস অনুরোধ সময়সীমা শেষ",
  "common.requestTips8": 'সিস্টেম ইন্টারফেস',
  "common.requestTips9": 'ব্যতিক্রম',
  "common.iknow": 'আমি জানি',
  "common.logoutSuccess": "লগআউট সফল",
  
  // আরো জানতে কম্পোনেন্ট
  "common.knowMore.title": 'আরও জানতে, অনুগ্রহ করে নর্থ এনার্জির সাথে যোগাযোগ করুন',
  "common.knowMore.email": 'যোগাযোগের ইমেইল',
  "common.knowMore.phone": 'যোগাযোগের ফোন',
  "common.knowMore.wechat": 'যোগাযোগের WeChat',
  "common.knowMore.website": 'অফিসিয়াল ওয়েবসাইট',
  "common.knowMore.address": 'যোগাযোগের ঠিকানা',
  "common.knowMore.addressDetail": 'কক্ষ ১২০৫, ১৩০১, বিল্ডিং ৫, কিংহে রোড ৮, হুয়াংজিনকেং, হুয়াংজিয়াং, ডংগুয়ান, গুয়াংডং প্রদেশ',
  
  // স্থানীয় সংযোগ কম্পোনেন্ট
  "common.localConnection": 'স্থানীয় সংযোগ',
  "common.operateInApp": 'অনুগ্রহ করে APP-তে অপারেট করুন!',
  
  "common.enbleStaus": "সক্রিয় অবস্থা",
  "common.battery.status": "চার্জ না ডিসচার্জ না",

  'account.forgetThePassword': 'পাসওয়ার্ড ভুলে গেছেন',
    'account.logInDirectly': 'সরাসরি লগইনে যান',
    'account.tips1': 'পৃষ্ঠা রিডিরেক্ট হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'account.tips2': 'অনুগ্রহ করে প্রথমে ব্যবহারকারীর নির্দেশাবলী দেখুন এবং সম্মতি দিন!',
    'account.autoLogin': 'স্বয়ংক্রিয় লগইন',
    'account.userLogin': 'ব্যবহারকারী লগইন',
    'account.registerTips': 'এখনও কোনো অ্যাকাউন্ট নেই? এখানে ক্লিক করে নিবন্ধন করুন',
    'account.userEmail': 'ব্যবহারকারীর নাম/ইমেইল',
    'account.userEmailTips': 'অনুগ্রহ করে ব্যবহারকারীর নাম/ইমেইল লিখুন',
    'account.password': 'পাসওয়ার্ড',
    'account.passwordTips': 'অনুগ্রহ করে পাসওয়ার্ড লিখুন',
    'account.submit': 'জমা দিন',
    'account.submitTips': 'জমা দেওয়া হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'account.otherLoginTips': 'অথবা অন্য লগইন পদ্ধতি নির্বাচন করুন',
    'account.userRegistration': 'ব্যবহারকারী নিবন্ধন',
    'account.userName': 'ব্যবহারকারীর নাম',
    'account.userNameTips': 'অনুগ্রহ করে ব্যবহারকারীর নাম লিখুন',
    'account.emailTips1': 'অনুগ্রহ করে ইমেইল ঠিকানা লিখুন',
    'account.emailTips2': 'ইমেইল ঠিকানার ফরম্যাট সঠিক নয়',
    'account.phone': 'ফোন নম্বর',
    'account.phoneTips1': 'অনুগ্রহ করে ফোন নম্বর লিখুন',
    'account.phoneTips2': 'ফোন নম্বর সঠিক নয়',
    'account.phoneTips3': 'অনুগ্রহ করে ফোন নম্বর লিখুন',
    'account.passwordTips1': 'অনুগ্রহ করে ৬-৩০ অক্ষরের পাসওয়ার্ড লিখুন',
    'account.passwordTips2': 'পাসওয়ার্ডের ফরম্যাট ভুল, পাসওয়ার্ড ইংরেজি সংখ্যা এবং আন্ডারস্কোর হাইফেন ডট দ্বারা গঠিত, দৈর্ঘ্য ৬-১২ অক্ষর',
    'account.passwordTips3': 'দুবার লেখা পাসওয়ার্ড মেল খায় না, অনুগ্রহ করে পরীক্ষা করে পুনরায় লিখুন!',
    'account.passwordTips4': 'অনুগ্রহ করে পাসওয়ার্ড লিখুন, পাসওয়ার্ড ইংরেজি সংখ্যা এবং আন্ডারস্কোর হাইফেন ডট দ্বারা গঠিত',
    'account.passwordTips5': 'পাসওয়ার্ড নিশ্চিত করুন',
    'account.passwordTips6': 'অনুগ্রহ করে নিশ্চিতকরণ পাসওয়ার্ড লিখুন',
    'account.passwordTips7': 'দুবার লেখা পাসওয়ার্ড মেল খায় না, অনুগ্রহ করে পরীক্ষা করে পুনরায় লিখুন!',
    'account.passwordTips8': 'অনুগ্রহ করে নিশ্চিতকরণ পাসওয়ার্ড লিখুন',
    'account.passwordTips9': 'অভিনন্দন, আপনার নিবন্ধন সফল!',
    'account.passwordTips10': 'আপনার ব্যবহারকারীর নাম হল：',
    'account.emailIs': 'ইমেইল হল：',
    'account.goToLoginPage': 's সেকেন্ড পর স্বয়ংক্রিয়ভাবে লগইন পৃষ্ঠায় রিডিরেক্ট হবে',
    'account.goLogin': 'লগইনে যান',
    'account.goRegister': 'নিবন্ধন',
    'account.loginSuccess': 'লগইন সফল',
    'account.email': 'ইমেইল',
    'account.sologn': 'আপনার জন্য একচেটিয়া শক্তি সমাধান তৈরি করার জন্য যত্নশীল',
    'account.pleaseAgree': 'আমি পড়েছি এবং সম্মতি দিয়েছি',
    'userAgreement.privacyPolicy': 'গোপনীয়তা নীতি',

    "account.code": "যাচাইকরণ কোড",
    "account.codeTips": "অনুগ্রহ করে যাচাইকরণ কোড লিখুন",
    "account.codeTips2": "যাচাইকরণ কোড সঠিক নয়",

    "account.inviteCodeTips": "অনুগ্রহ করে আমন্ত্রণ কোড লিখুন",
    "account.inviteCodeHint": "আমন্ত্রণ কোড পেতে অনুগ্রহ করে ইনস্টলার বা রক্ষণাবেক্ষণ কর্মীদের সাথে যোগাযোগ করুন",
    "account.modifyPasswordByAccount": "অ্যাকাউন্টের মাধ্যমে পাসওয়ার্ড পরিবর্তন",
    "account.modifyPasswordByEmail": "ইমেইলের মাধ্যমে পাসওয়ার্ড পরিবর্তন",
    "account.getPasswordByAccount": "অ্যাকাউন্টের মাধ্যমে পাসওয়ার্ড পুনরুদ্ধার",
    "account.getPasswordByEmail": "ইমেইলের মাধ্যমে পাসওয়ার্ড পুনরুদ্ধার",

    "account.sendEmailTips": "যাচাইকরণ কোড ইমেইলে পাঠানো হয়েছে, অনুগ্রহ করে ইমেইল চেক করুন",
    "account.name": "অ্যাকাউন্টের নাম",
    "account.newPassword": "নতুন পাসওয়ার্ড",
    "account.confirmNewPassword": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
    "account.nameTips": "অনুগ্রহ করে অ্যাকাউন্টের নাম লিখুন",
    "account.passwordModifySuccess": "পাসওয়ার্ড পরিবর্তন সফল",
    "account.emailCode": "ইমেইল যাচাইকরণ কোড",
    "account.emailCodeTips": "অনুগ্রহ করে ইমেইল যাচাইকরণ কোড লিখুন",
    "account.emailCodeTips2": "ইমেইল যাচাইকরণ কোড সঠিক নয়",
    "account.emailModifySuccess": "পাসওয়ার্ড পরিবর্তন সফল",
    "account.passworTips1": "আপনার পাসওয়ার্ড সফলভাবে রিসেট হয়েছে!",
    "account.passwordTips11": "অনুগ্রহ করে নিশ্চিতকরণ পাসওয়ার্ড লিখুন",
    "account.passwordTips12": "অনুগ্রহ করে নতুন পাসওয়ার্ড লিখুন",
    "account.nickname": "ব্যবহারকারীর ডাকনাম",
    "account.modifyNickname": "ব্যবহারকারীর ডাকনাম পরিবর্তন",
    "account.modifyNicknameSuccess": "ব্যবহারকারীর ডাকনাম পরিবর্তন সফল!",
    "account.nicknameTips": "অনুগ্রহ করে ব্যবহারকারীর ডাকনাম লিখুন",
    'account.nicknameError': 'ব্যবহারকারীর ডাকনাম পরিবর্তন ব্যর্থ!',

    "account.login": 'লগইন',
    'account.quickRegister': 'দ্রুত নিবন্ধন',
    'account.sendCode': 'যাচাইকরণ কোড পাঠান',
    'account.sendTips': 's সেকেন্ড পর পুনরায় পাঠানো যাবে',
    "account.sendEmailIng": 'ইমেইল পাঠানো হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'account.emailNotEmpty': 'ইমেইল ঠিকানা খালি থাকতে পারে না',
    'account.registerAccount': 'অ্যাকাউন্ট নিবন্ধন',
    'account.registerWelcome': 'SusprSafe-এ স্বাগতম',
    'account.usernameLimit': 'ব্যবহারকারীর নাম শুধুমাত্র অক্ষর দিয়ে শুরু হতে পারে এবং শুধুমাত্র অক্ষর, সংখ্যা, আন্ডারস্কোর থাকতে পারে, দৈর্ঘ্য ৫-১৫ অক্ষরের মধ্যে',

    'copyright.desc2': 'ওয়েবসাইট রেজিস্ট্রেশন তথ্য：粤ICP备2021169764号',

    'editUserInfo.editUserInformation': 'ব্যবহারকারীর তথ্য সম্পাদনা',
    'editUserInfo.modifyUsername': 'ব্যবহারকারীর নাম পরিবর্তন',
    'editUserInfo.changePictures': 'প্রোফাইল ছবি পরিবর্তন',
    'editUserInfo.savePicturesSuccess': 'ব্যবহারকারীর প্রোফাইল ছবি সফলভাবে সংরক্ষিত',
    'editUserInfo.saveError': 'সংরক্ষণ ব্যর্থ',
    'editUserInfo.pictureLimit':'ছবি অবশ্যই 2M-এর কম হতে হবে',
    'editUserInfo.uploadPicture':'প্রোফাইল ছবি আপলোড',
    'editUserInfo.picturePreview':'প্রিভিউ',
    
    'editUserInfo.bindPhoneNumber': 'ফোন নম্বর বাইন্ড',
    'editUserInfo.bindEmail': 'ইমেইল বাইন্ড',
    'editUserInfo.changePassword': 'পাসওয়ার্ড পরিবর্তন',

    'editUserInfo.notificationSettings': 'বিজ্ঞপ্তি সেটিংস',
    'editUserInfo.editAccount': 'ব্যবহারকারীর অ্যাকাউন্ট তথ্য সম্পাদনা',
    'editUserInfo.waitBingting': 'বাইন্ড করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'editUserInfo.collapse': 'সংকুচিত',
    'editUserInfo.modifyBinding': 'বাইন্ডিং পরিবর্তন',
    
    'editUserInfo.emailAddress': 'ইমেইল ঠিকানা',
    'editUserInfo.tips1': 'ইমেইল বাইন্ড সফল',
    'editUserInfo.tips2': 'সংরক্ষণ ব্যর্থ',
    'editUserInfo.tips3': 'ইমেইল যাচাইকরণ কোড পাঠানো হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'editUserInfo.tips4': 'যাচাইকরণ কোড ইমেইল xxxx-এ পাঠানো হয়েছে, অনুগ্রহ করে চেক করুন',
    'editUserInfo.tips5': 'যাচাইকরণ কোড পাঠাতে ব্যর্থ!',
    'editUserInfo.tips6': 'ইতিমধ্যে ফোন নম্বর বাইন্ড করা আছে',
    'editUserInfo.tips7': 'ইতিমধ্যে ইমেইল বাইন্ড করা আছে',
    'editUserInfo.emailTips1': 'অনুগ্রহ করে ইমেইল ঠিকানা লিখুন',
    'editUserInfo.emailTips2': 'ইমেইল ঠিকানার ফরম্যাট সঠিক নয়',
    'editUserInfo.emailTips3': 'xxxxs পর পুনরায় পাঠানো যাবে',
    'editUserInfo.emailTips4': 'যাচাইকরণ কোড পাঠান',
    'editUserInfo.emailTips5': 'ইমেইল যাচাইকরণ কোড খালি থাকতে পারে না',
    'editUserInfo.emailTips6': 'ইমেইল যাচাইকরণ কোড সঠিক নয়',
    'editUserInfo.emailCode': 'ইমেইল যাচাইকরণ কোড',
    'editUserInfo.save': 'সংরক্ষণ',

    'editUserInfo.phoneTips1': 'ফোন নম্বর বাইন্ড সফল',
    'editUserInfo.phoneTips2': 'ফোন যাচাইকরণ কোড পাঠানো হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'editUserInfo.phoneTips3': 'SMS যাচাইকরণ কোড ফোন xxxx-এ পাঠানো হয়েছে, অনুগ্রহ করে চেক করুন',
    'editUserInfo.phoneTips4': 'SMS যাচাইকরণ কোড পাঠাতে ব্যর্থ!',
    'editUserInfo.phoneTips5': 'অনুগ্রহ করে ফোন নম্বর লিখুন',
    'editUserInfo.phoneTips6': 'ফোন নম্বরের ফরম্যাট সঠিক নয়',
    'editUserInfo.phoneTips7': 'SMS যাচাইকরণ কোড পাঠান',
    'editUserInfo.phoneTips8': 'SMS যাচাইকরণ কোড',
    'editUserInfo.phoneTips9': 'ফোন যাচাইকরণ কোড খালি থাকতে পারে না',
    'editUserInfo.phoneTips10': 'ফোন যাচাইকরণ কোড সঠিক নয়',
    'editUserInfo.phone': 'ফোন নম্বর',


    'editUserInfo.noticeTips1': 'বিজ্ঞপ্তি কনফিগারেশন পেতে ব্যর্থ!',
    'editUserInfo.noticeTips2': 'বিজ্ঞপ্তি সেটিংস সফলভাবে সংরক্ষিত!',
    'editUserInfo.noticeTips3': 'ব্যাটারি কম বিজ্ঞপ্তি',
    'editUserInfo.noticeTips4': 'চার্জিং স্টেশন চার্জ সম্পূর্ণ বিজ্ঞপ্তি',
    'editUserInfo.errorNotification': 'ত্রুটি বিজ্ঞপ্তি',
    'editUserInfo.updateNotification': 'আপডেট বিজ্ঞপ্তি',
    'editUserInfo.monthlyStatisticsNotification': 'মাসিক পরিসংখ্যান বিজ্ঞপ্তি',
    'editUserInfo.notificationMethod': 'গ্রহণ পদ্ধতি',

    'editUserInfo.userNameTips1': 'ব্যবহারকারীর নাম সফলভাবে সংরক্ষিত',
    'editUserInfo.userNameTips2': 'ব্যবহারকারীর নাম সংরক্ষণ ব্যর্থ',
    'editUserInfo.userNameTips3': 'অনুগ্রহ করে ব্যবহারকারীর নাম লিখুন',
    'editUserInfo.userNameTips4': 'ব্যবহারকারীর নামের ফরম্যাট সঠিক নয়, অবশ্যই সংখ্যা আন্ডারস্কোর ইংরেজি দিয়ে গঠিত',
    'editUserInfo.userNameTips5': 'অনুগ্রহ করে ব্যবহারকারীর নাম লিখুন',
    'editUserInfo.userNameTips6': 'সংরক্ষণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    'editUserInfo.userName': 'ব্যবহারকারীর নাম',

    'editUserInfo.avatorTips': 'প্রোফাইল ছবি পরিবর্তনের জন্য ক্লিক করুন',
    'editUserInfo.verifyCodeTips1': 'অনুগ্রহ করে আপনার প্রাপ্ত যাচাইকরণ কোড লিখুন：',
    'editUserInfo.verifyCodeTips2': 'আপনার অ্যাকাউন্টের নিরাপত্তার জন্য, অনুগ্রহ করে মূল ফোন নম্বরে যাচাইকরণ কোড পাঠানোর জন্য নিম্নোক্ত বোতাম ক্লিক করুন：',
    'editUserInfo.verifyCodeTips3': 'যাচাইকরণ কোড পাঠান',
    'editUserInfo.verifyCodeTips4': 'মূল ফোন যাচাই সম্পূর্ণ, অনুগ্রহ করে নতুন বাইন্ড ফোন নম্বর লিখুন',
    'editUserInfo.verifyCodeTips5': 'আপনার অ্যাকাউন্টের নিরাপত্তার জন্য, অনুগ্রহ করে মূল ইমেইলে যাচাইকরণ কোড পাঠানোর জন্য নিম্নোক্ত বোতাম ক্লিক করুন：',
    'editUserInfo.verifyCodeTips6': 'মূল ইমেইল যাচাই সম্পূর্ণ, অনুগ্রহ করে নতুন ইমেইল লিখুন',
    'editUserInfo.verifyCodeTips7': 'পুরাতন পাসওয়ার্ড',
    'editUserInfo.verifyCodeTips8': 'অনুগ্রহ করে প্রথমে ইমেইল বাইন্ড করুন!',
    'editUserInfo.verifyCodeTips9': 'যাচাইকরণ কোড ইমেইলে পাঠানো হয়েছে, অনুগ্রহ করে ইমেইল চেক করুন',
    "editUserInfo.verifyCodeTips10": '，স্বয়ংক্রিয়ভাবে লগইন পৃষ্ঠায় রিডিরেক্ট হবে',

    "hems.notice.title": "বিজ্ঞপ্তির শিরোনাম", 
   "hems.notice.content": "বিজ্ঞপ্তির বিষয়বস্তু", 
   "hems.notice.operate": "অপারেশন",
   "hems.notice.noRead": "অপঠিত",
   "hems.notice.read": "পঠিত",
   "hems.notice.warning": "অনুস্মারক",
   "hems.notice.error": "ব্যতিক্রম",
   "hems.notice.success": "পরিসংখ্যানগত নিষ্পত্তি",
   "hems.notice.sys": "সিস্টেম তথ্য",
   "hems.notice.operateSuccess": "অপারেশন সফল",
   "hems.notice.operateTips": "অনুগ্রহ করে অপারেট করার জন্য আইটেম নির্বাচন করুন",

    // হোম পেজ
   "hems.home.selfuseRate": "স্ব-উৎপাদন এবং স্ব-ব্যবহারের হার",
   "hems.home.percent": "শতাংশ",
   "hems.home.todayData": "আজকের ডেটা",
   "hems.home.todayPowerGeneration": "আজকের বিদ্যুৎ উৎপাদন",
   "hems.home.salesIncome": "বিদ্যুৎ বিক্রয়ের আয়",
   "hems.home.saved": "আপনার জন্য সাশ্রয় করেছে",
   "hems.home.reduce": "কার্বন ফুটপ্রিন্ট কমানো",
   "hems.home.tips1": "কোনো ডেটা নেই, আপনি এখনও xxxx বাইন্ড করেননি",
   "hems.home.criticalLoad": "গুরুত্বপূর্ণ লোড",
   "hems.home.keyVoltage": "গুরুত্বপূর্ণ ভোল্টেজ",
   "hems.home.householdLoad": "পারিবারিক লোড",
   "hems.home.householdVoltage": "পারিবারিক ভোল্টেজ",
   "hems.home.generalLoad": "সাধারণ লোড",
   "hems.home.generalVoltage": "সাধারণ ভোল্টেজ",
   "hems.home.batteryHealth": "ব্যাটারির স্বাস্থ্য",
   "hems.home.averageTemp": "গড় তাপমাত্রা",
   "hems.home.gridLoad": "গ্রিড লোড",
   "hems.home.toggeleDataSource": "বর্তমান প্রদর্শিত ডেটা পরিবর্তিত হয়েছে:",
   "hems.home.toggleTips": "আপনি কি নিশ্চিত যে পরিবর্তন করতে চান?",
   "hems.home.modeSending": "মোড কমান্ড পাঠানো হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...",
   "hems.home.modeSuccess": "মোড পরিবর্তন কমান্ড সফলভাবে পাঠানো হয়েছে!",
   "hems.home.isOnline": "অনলাইন কিনা",
   "hems.home.useStatus": "ব্যবহারের অবস্থা",
   "hems.home.workModeText": 'বর্তমান কাজের মোড：',
   "hems.home.toggleDataSourceText": 'বর্তমান প্রদর্শিত ডেটা পরিবর্তিত হয়েছে：',
   "hems.ev.charge.status": "চার্জিং স্থিতি",
   "hems.ev.charge.time": "চার্জিং সময়কাল",
   "hems.ev.charge.count": "রিয়েল-টাইম চার্জিং পরিমাণ",
   "hems.ev.charge.status.empty":"নিষ্ক্রিয়",
   "hems.ev.charge.status.ing":"গান প্লাগ চার্জিং",
   "hems.ev.charge.status.null":"গান প্লাগ কিন্তু চার্জিং নয়",
   "hems.ev.charge.status.error":"ত্রুটি",
   "hems.hour":"ঘন্টা",
   "hems.minue":"মিনিট",
   "hems.ev.chagre.number": "চার্জিং স্টেশন নম্বর",

   // ব্যবহারকারী গাইড
   "hems.userGuide.selfUse": "স্ব-উৎপাদন এবং স্ব-ব্যবহার",
   "hems.userGuide.selfUseTips": "অগ্রাধিকার ভিত্তিতে সোলার পাওয়ার ব্যবহার, অপর্যাপ্ত হলে গ্রিড থেকে পূরণ",
   "hems.userGuide.economyMode": "অর্থনৈতিক মোড",
   "hems.userGuide.economyModeTips": "বিদ্যুতের দামের ভিত্তিতে বিদ্যুৎ ব্যবহারের কৌশল অপ্টিমাইজ",
   "hems.userGuide.emergencyMode": "জরুরি মোড",
   "hems.userGuide.emergencyModeTips": "অগ্রাধিকার ভিত্তিতে গুরুত্বপূর্ণ লোড সরবরাহ নিশ্চিত",

   // চার্ট পৃষ্ঠা
   "hems.history.energyStatistics": "শক্তি পরিসংখ্যান",
   "hems.history.revenueStatistics": "আয়ের পরিসংখ্যান",
   "hems.history.greenStatistics": "সবুজ নিঃসরণ হ্রাস",
   "hems.history.revenueTitle": "মোট বিদ্যুৎ বিক্রয়ের আয়",
   "hems.history.savingsTitle": "মোট সাশ্রয়",
   "hems.history.carbonTitle": "মোট কার্বন নিঃসরণ হ্রাস",
   "hems.history.day": "দিন",
   "hems.history.month": "মাস",
   "hems.history.year": "বছর",
   "hems.history.beforeDay": "পূর্ববর্তী দিন",
   "hems.history.afterDay": "পরবর্তী দিন",
   "hems.history.beforeMonth": "গত মাস",
   "hems.history.afterMonth": "পরবর্তী মাস",
   "hems.history.beforeYear": "গত বছর",
   "hems.history.afterYear": "পরবর্তী বছর",
   "hems.history.totalUse": 'মোট ব্যবহার',
   "hems.history.fullScreen": 'পূর্ণ স্ক্রিন',
   "hems.history.timeSelect": "তারিখ নির্বাচন",
   "sync.tips1": "সিঙ্ক ডেটা কমান্ড সফলভাবে পাঠানো হয়েছে!",
   "sync.tips2":"ডেটা সিঙ্ক চলছে, ডেটার পরিমাণ বেশি হওয়ায় সিঙ্ক প্রক্রিয়ায় কিছু সময় লাগবে, অনুগ্রহ করে আধা ঘন্টা পর আবার চেক করুন~",
   "sync.tips3": "ডিভাইস সিঙ্ক ডেটা দেরি হতে পারে, যদি ডেটায় অস্বাভাবিকতা আবিষ্কার করেন, অনুগ্রহ করে ক্লিক করুন:",
   "sync.tips4": "ডেটা সিঙ্ক",

   "charge.info": "চার্জিং স্টেশনের তথ্য",
    "news.loading": 'লোড হচ্ছে...',
    "news.noMore": 'আর কিছু নেই',
    "hems.pv.power": 'সোলার পাওয়ার সাপ্লাই',

  // UEH নির্দিষ্ট
  "ueh.sellPower": "বিদ্যুৎ বিক্রয়ের পরিমাণ",
  
  "menu.home": "হোম পেজ",
  "menu.history": "ঐতিহাসিক ডেটা",
  "menu.device": "ডিভাইস",
  "menu.settings": "সেটিংস",
  "menu.messageCenter": "বার্তা কেন্দ্র",
  "menu.help": "সাহায্য ও সহায়তা",
  "menu.mine": "আমার",


  "mine.userSetting": "ব্যবহারকারী সেটিংস",
  "mine.terminalSetting": "টার্মিনাল বেসিক সেটিংস",
  "mine.uploadCloud": "ক্লাউড ডেটা ব্যাকআপ",
  "mine.changeVersion": "আপডেট চেক",
  "mine.language": "ভাষা পরিবর্তন",
  "mine.about": "সম্পর্কে",
  "mine.feedback": "মতামত ও প্রতিক্রিয়া",
  "mine.logout": "লগআউট",
  "mine.logoutAccount": "অ্যাকাউন্ট মুছুন",

  "mine.logoutAccountTips": "নাম []এর অ্যাকাউন্ট মুছুন",
  "mine.logoutAccountTips1": "[]বাইন্ডকৃত অ্যাকাউন্ট মুছুন",
  "mine.logoutAccountCare": "মুছে ফেলার আবেদনের সংশ্লিষ্ট বিষয়:",
  "mine.logoutAccountCare1": "১. অ্যাকাউন্ট নিরাপদ অবস্থায় আছে",
  "mine.logoutAccountCare1-1": "অ্যাকাউন্ট বর্তমানে স্বাভাবিক ব্যবহারের অবস্থায় আছে, চুরি, লঙ্ঘন, নিষেধাজ্ঞা ইত্যাদি ঝুঁকি নেই।",
  "mine.logoutAccountCare2": "২. অ্যাকাউন্ট অনুমোদন, বাইন্ডিং সম্পর্ক বাতিল",
  "mine.logoutAccountCare2-1": "অ্যাকাউন্ট অন্যান্য তৃতীয় পক্ষের প্ল্যাটফর্মের সাথে অনুমোদন ইত্যাদি বাতিল করেছে।",
  "mine.logoutAccountCare3": "৩. অ্যাকাউন্ট মুছে ফেলার পর পুনরুদ্ধার করা যাবে না, ব্যবহারকারীর ডেটা সব মুছে ফেলা হবে",
  "mine.logoutAccountCare3-1": "অ্যাকাউন্ট মুছে ফেলার পর, বাইন্ডকৃত ফোন এবং ইমেইল ইত্যাদি অ্যাকাউন্ট এবং সংশ্লিষ্ট ডেটা সব মুছে ফেলা হবে এবং পুনরুদ্ধার করা যাবে না।",
  "mine.confirmLogout": "মুছে ফেলা নিশ্চিত করুন",
  "mine.logoutSuccess": "অ্যাকাউন্ট সফলভাবে মুছে ফেলা হয়েছে!",


  "mine.feedbackIssues": "সমস্যার প্রতিক্রিয়া",
  "mine.feedQuantity": "পরিমাণ",
  "mine.feedAmount": "সর্বোচ্চ ৯টি ছবি, সর্বোচ্চ ১MB/টি",

  "mine.notice.fail": "বিজ্ঞপ্তি কনফিগারেশন পেতে ব্যর্থ!",
  "mine.notice.saveSuccess": "বিজ্ঞপ্তি সেটিংস সফলভাবে সংরক্ষিত!",
  "mine.notice.saveFail": "সংরক্ষণ ব্যর্থ!",
  "mine.notice.title": "বিজ্ঞপ্তি সেটিংস",
  "mine.notice.batteryLow": "ব্যাটারি কম বিজ্ঞপ্তি",
  "mine.notice.chargingFinish": "চার্জিং স্টেশন চার্জ সম্পূর্ণ বিজ্ঞপ্তি",
  "mine.notice.error": "ত্রুটি বিজ্ঞপ্তি",
  "mine.notice.update": "আপডেট বিজ্ঞপ্তি",
  "mine.notice.monthly": "মাসিক পরিসংখ্যান বিজ্ঞপ্তি",
  "mine.notice.receiveType": "গ্রহণ পদ্ধতি",

  "mine.language.welcome": "SusprSafe-এ স্বাগতম",
  "mine.language.desc1": "অনুগ্রহ করে আপনার অঞ্চল অনুযায়ী ভাষার সংস্করণ সেট করুন",
  "mine.language.desc2": "আপনি যেকোনো সময় অ্যাপ্লিকেশনের সেটিংসের মাধ্যমে পরিবর্তন করতে পারেন",

  "mine.userInfo.avatar":"প্রোফাইল ছবি",
  "mine.userInfo.nickname":"ডাকনাম",
  "mine.userInfo.password":"পাসওয়ার্ড",
  "mine.userInfo.changePassword":"পাসওয়ার্ড পরিবর্তন",
  "mine.userInfo.setPassword":"পাসওয়ার্ড সেট",
  "mine.userInfo.phoneNumber":"ফোন নম্বর",
  "mine.userInfo.bindPhone":"ফোন নম্বর বাইন্ড",
  "mine.userInfo.bindEmail":"ইমেইল বাইন্ড",
  "mine.loginExpired":"লগইনের মেয়াদ শেষ, অনুগ্রহ করে পুনরায় লগইন করুন",
  "mine.userInfo.title":"ব্যবহারকারীর তথ্য",
  "mine.userInfo.bind":"বাইন্ড",
  "mine.userInfo.modify": "পরিবর্তন",
  "mine.userInfo.modifyNickname":"ডাকনাম পরিবর্তন",
  "mine.userInfo.userNickname":"ব্যবহারকারীর ডাকনাম",
  "mine.userInfo.selectPic":"অনুগ্রহ করে আপলোডের জন্য ছবি নির্বাচন করুন",
  "mine.userInfo.saveSuccess":"সফলভাবে সংরক্ষিত",
  "mine.userInfo.uploadFail":"আপলোড ব্যর্থ",
  "mine.userInfo.avatarSaveSuccess":"প্রোফাইল ছবি সফলভাবে সংরক্ষিত",
  "mine.userInfo.nameTips1":"ব্যবহারকারীর ডাকনাম খালি থাকতে পারে না",
  "mine.userInfo.nameTips2":"অনুগ্রহ করে ব্যবহারকারীর ডাকনাম লিখুন",

  "common.pleaseSelect": "অনুগ্রহ করে নির্বাচন করুন",
  "question.commonQuestions": "সাধারণ প্রশ্ন",
  "account.toggleLanguage": 'ভাষা পরিবর্তন',
  "account.localConnection": "স্থানীয় সংযোগ",
  "account.selectLanguage": 'অনুগ্রহ করে ভাষা নির্বাচন করুন',
  "account.sendEmailToast": "যাচাইকরণ কোড ইমেইল xxx-এ পাঠানো হয়েছে, অনুগ্রহ করে ইমেইল চেক করুন",
  "account.emailError": "ইমেইলের ফরম্যাট সঠিক নয়",
  "account.sendEmailFail": "পাঠাতে ব্যর্থ, অনুগ্রহ করে পুনরায় চেষ্টা করুন",
  
  "common.submitting": "জমা দেওয়া হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...",

  "device.page.noData": "কোনো ডেটা নেই, এই পৃষ্ঠা শুধুমাত্র অ্যাপে প্রিভিউ করা যায়",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
 
};